import Vue from 'vue';
window.Vue = Vue;


require('./setup/axios');
require('./setup/vue-helper');
require('./setup/vue-plugins');
require('./setup/vue-components');
require('./setup/ie11');
require('./setup/polyfills');

window.app = new Vue({el: '#app'});
